// MUNYA OS · RUM reporter de Web Vitals
// § 15.bis SLO 1 (LCP < 2s p75) + § 18.6-bis presupuestos de Web Vitals.
//
// Sólo activo en prod sobre HTTPS para no contaminar las métricas con datos dev.
// Usa `navigator.sendBeacon` cuando está disponible (entrega fiable al unload).

import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from 'web-vitals';

const ENDPOINT = '/api/v1/observability/rum/web-vitals';

let sessionId: string | undefined;

function getSessionId(): string {
  if (sessionId) return sessionId;
  const existing = sessionStorage.getItem('mn_rum_session');
  if (existing) {
    sessionId = existing;
    return existing;
  }
  // crypto.randomUUID requiere contexto seguro (https) · safe en prod
  const fresh =
    typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : Math.random().toString(36).slice(2);
  sessionStorage.setItem('mn_rum_session', fresh);
  sessionId = fresh;
  return fresh;
}

function send(metric: Metric): void {
  const payload = JSON.stringify({
    metric: metric.name,
    value: metric.value,
    rating: metric.rating,
    route: location.pathname,
    navigationType: metric.navigationType,
    sessionId: getSessionId(),
  });

  // sendBeacon entrega aunque la página se esté cerrando · ideal para LCP/CLS al unload.
  if (typeof navigator.sendBeacon === 'function') {
    const blob = new Blob([payload], { type: 'application/json' });
    if (navigator.sendBeacon(ENDPOINT, blob)) return;
  }

  // Fallback cuando sendBeacon no está disponible o falla.
  void fetch(ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch((e) => console.warn('[munya] web-vitals send failed', e));
}

export function startWebVitalsReporter(): void {
  if (location.protocol !== 'https:') return;
  // Las 5 métricas estándar 2024+: LCP, INP (reemplaza FID), CLS, FCP, TTFB.
  onLCP(send);
  onINP(send);
  onCLS(send);
  onFCP(send);
  onTTFB(send);
}
